import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Utility } from '../../Common/Services/utility';
import { AppMessage } from './../../Common/appMessage';
import { AdmManageProctorAlertConfigService } from './adm-manage-proctor-alert-config.service';
import { AppConfig } from './../../Common/appConfiguration';
import { FeatureFlagService, ToggleName } from 'app/Common/Services/feature-flag.service';

@Component({
  selector: 'app-adm-manage-proctor-alert-config',
  templateUrl: './adm-manage-proctor-alert-config.component.html',
  styleUrls: ['./adm-manage-proctor-alert-config.component.css'],
  providers: [AdmManageProctorAlertConfigService, FeatureFlagService]
})
export class AdmManageProctorAlertConfigComponent implements OnInit, OnDestroy {
  form: FormGroup;
  isSaveDisable: boolean = true; // disable/enable save/edit button
  disableField: boolean = true; //used for custom-time-control

  constructor(private featureFlags: FeatureFlagService, public _utility: Utility, private _appMessage: AppMessage, private _admManageProctorAlertConfigService: AdmManageProctorAlertConfigService) {
    this.form = new FormGroup({
      maxInactiveTime: new FormControl('00:00', Validators.required),
      maxActiveSession: new FormControl('0', [Validators.required, Validators.pattern(AppConfig.onlyNumericRegEx)]),
    });
  }

  private redirect(): void {
    window.location.assign("/ies/internal/manage-proctor-alert");
  }

  ngOnInit() {
    this.featureFlags.on("ready", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_MANAGE_PROCTOR_ALERT_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.on("update", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_MANAGE_PROCTOR_ALERT_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.start();
    this.getProctorAlertConfig();
    this.form.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe(form => {
        if (!this.form.disabled && this.form.dirty) {
          this._utility.setTxnStatus(true); //show confirm box for FORM changes
        }
      });
  }

  ngOnDestroy(): void {
      this.featureFlags.stop();
  }

  // Called method once page load to fill the record. Also this method will call the method getProctorAlertConfig() to connect API.
  getProctorAlertConfig() {
    this._utility.addLoaderCount();
    this._admManageProctorAlertConfigService.getProctorAlertConfig()
      .subscribe(
      (response: any) => {
        this._utility.onSuccessCallback(response, null, () => {
          if (response && response.response) {
            let data = response.response;
            this.form.patchValue(data);            
            this._utility.disableEnableForm(this.form, true);
          }
        });
      },
      error => {
        this._utility.onErrorCallback(error);
      });
  }

  //call api to save edited changes
  onSaveForm() {
    if (this.form.invalid) return;
    let formData = this.form.getRawValue();
    this._utility.addLoaderCount();
    this._admManageProctorAlertConfigService.updateProctorAlertConfig(formData).subscribe(response => {

      this._utility.onSuccessCallback(response, this._appMessage.getItem['UMsg00080'], () => {
        this.getProctorAlertConfig(); // load record after new record is added
        this.isSaveDisable = true;
        this.disableField = true;
        this._utility.disableEnableForm(this.form, true);
        this._utility.clearTxnStatus(); // close confirm box for FORM changes        
      });
    }, error => this._utility.onErrorCallback(error))
  }

  //enable form to edit
  onEdit() {
    this._utility.disableEnableForm(this.form, false);
    this.isSaveDisable = false;
    this.disableField = false;
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-proctor-alert-config/adm-manage-proctor-alert-config.component.ts